import PhotoSwipe from "photoswipe";
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";

export default class Gallery {
  constructor(elements) {
    window.addEventListener('load', () => {
      let dialog = document.createElement("DIV");
      let footer = document.querySelector('.page-footer');
      footer.parentNode.insertBefore(dialog, footer.nextSibling);
      dialog.outerHTML = `<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="pswp__bg"></div>
      <div class="pswp__scroll-wrap">
        <!-- Container that holds slides.
            PhotoSwipe keeps only 3 of them in the DOM to save memory.
            Don't modify these 3 pswp__item elements, data is added later on. -->
        <div class="pswp__container">
          <div class="pswp__item"></div>
          <div class="pswp__item"></div>
          <div class="pswp__item"></div>
        </div>

        <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. -->
        <div class="pswp__ui pswp__ui--hidden">

          <div class="pswp__top-bar">

            <!--  Controls are self-explanatory. Order can be changed. -->

            <div class="pswp__counter"></div>

            <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>

            <!-- Preloader demo https://codepen.io/dimsemenov/pen/yyBWoR -->
            <!-- element will get class pswp__preloader--active when preloader is running -->
            <div class="pswp__preloader">
              <div class="pswp__preloader__icn">
                <div class="pswp__preloader__cut">
                  <div class="pswp__preloader__donut"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
            <div class="pswp__share-tooltip"></div>
          </div>

          <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
          </button>

          <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
          </button>

          <div class="pswp__caption">
            <div class="pswp__caption__center"></div>
          </div>

        </div>
      </div></div>`;
      this.init(elements);
    })
  }

  init(gallerySelector){
    Element.prototype.parents = function(selector) {
      var elements = [];
      var elem = this;
      var ishaveselector = selector !== undefined;

      while ((elem = elem.parentElement) !== null) {
        if (elem.nodeType !== Node.ELEMENT_NODE) {
          continue;
        }

        if (!ishaveselector || elem.matches(selector)) {
          elements.push(elem);
        }
      }

      return elements;
    };

    var parseThumbnailElements = function(el) {
      var thumbElements = document.querySelectorAll(gallerySelector),
        numNodes = thumbElements.length,
        items = [],
        childElements,
        size,
        item;

      for(var i = 0; i < numNodes; i++) {
        el = thumbElements[i];

        // include only element nodes
        if(el.nodeType !== 1) {
          continue;
        }

        childElements = el.children;
        size = [el.querySelector('img').getAttribute('width'), el.querySelector('img').getAttribute('height')];

        // create slide object
        let urls = el.querySelector('img').srcset.replace(/\s+[0-9]+(\.[0-9]+)?[wx]/g, "").split(/,/);

        item = {
          src: urls ? urls[urls.length - 1] : el.querySelector('img').src,
          w: parseInt(size[0], 10),
          h: parseInt(size[1], 10),
          author: false
        };

        item.el = el; // save link to element for getThumbBoundsFn
        item.msrc = el.querySelector('img').src; // thumbnail url
        item.title = el.querySelector('figcaption') ? el.querySelector('figcaption').innerText : '';

        // original image
        item.o = {
          src: item.src,
          w: item.w * 2,
          h: item.h * 2
        };

        items.push(item);
      }

      return items;
    };

    // find nearest parent element
    var closest = function closest(el, fn) {
      return el && ( fn(el) ? el : closest(el.parentNode, fn) );
    };

    var onThumbnailsClick = function(e) {
      e = e || window.event;
      e.preventDefault ? e.preventDefault() : e.returnValue = false;

      var eTarget = e.target || e.srcElement;

      var clickedListItem = closest(eTarget, function(el) {
        return el.tagName === 'FIGURE';
      });

      if(!clickedListItem) {
        return;
      }

      var clickedGallery = clickedListItem.parentNode;
      var childNodes = document.querySelectorAll('.section__gallery figure'),
        numChildNodes = childNodes.length,
        nodeIndex = 0,
        index;

      for (var i = 0; i < numChildNodes; i++) {
        if(childNodes[i].nodeType !== 1) {
          continue;
        }

        if(childNodes[i] === clickedListItem) {
          index = nodeIndex;
          break;
        }
        nodeIndex++;
      }

      if(index >= 0) {
        openPhotoSwipe( index, clickedGallery );
      }
      return false;
    };

    var photoswipeParseHash = function() {
      var hash = window.location.hash.substring(1),
        params = {};

      if(hash.length < 5) { // pid=1
        return params;
      }

      var vars = hash.split('&');
      for (var i = 0; i < vars.length; i++) {
        if(!vars[i]) {
          continue;
        }
        var pair = vars[i].split('=');
        if(pair.length < 2) {
          continue;
        }
        params[pair[0]] = pair[1];
      }

      if(params.gid) {
        params.gid = parseInt(params.gid, 10);
      }

      return params;
    };

    var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
      var pswpElement = document.querySelectorAll('.pswp')[0],
        gallery,
        options,
        items;

      items = parseThumbnailElements(galleryElement);

      // define options (if needed)
      options = {
        bgOpacity: .7,
        galleryUID: galleryElement.getAttribute('data-pswp-uid'),

        getThumbBoundsFn: function(index) {
          // See Options->getThumbBoundsFn section of docs for more info
          var thumbnail = items[index].el.children[0],
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();

          return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
        },

        addCaptionHTMLFn: function(item, captionEl, isFake) {
          if(!item.title) {
            captionEl.children[0].innerText = '';
            return false;
          }
          captionEl.children[0].innerHTML = item.title +  (item.author ? '<br/><small>Photo: ' + item.author + '</small>' : '');
          return true;
        },

      };


      if(fromURL) {
        if(options.galleryPIDs) {
          // parse real index when custom PIDs are used
          // https://photoswipe.com/documentation/faq.html#custom-pid-in-url
          for(var j = 0; j < items.length; j++) {
            if(items[j].pid == index) {
              options.index = j;
              break;
            }
          }
        } else {
          options.index = parseInt(index, 10) - 1;
        }
      } else {
        options.index = parseInt(index, 10);
      }

      // exit if index not found
      if( isNaN(options.index) ) {
        return;
      }

      if(disableAnimation) {
        options.showAnimationDuration = 0;
      }

      // Pass data to PhotoSwipe and initialize it
      gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);

      // see: http://photoswipe.com/documentation/responsive-images.html
      var realViewportWidth,
        useLargeImages = false,
        firstResize = true,
        imageSrcWillChange;

      gallery.listen('beforeResize', function() {

        var dpiRatio = window.devicePixelRatio ? window.devicePixelRatio : 1;
        dpiRatio = Math.min(dpiRatio, 2.5);
        realViewportWidth = gallery.viewportSize.x * dpiRatio;


        if(realViewportWidth >= 1200 || (!gallery.likelyTouchDevice && realViewportWidth > 800) || screen.width > 1200 ) {
          if(!useLargeImages) {
            useLargeImages = true;
            imageSrcWillChange = true;
          }

        } else {
          if(useLargeImages) {
            useLargeImages = false;
            imageSrcWillChange = true;
          }
        }

        if(imageSrcWillChange && !firstResize) {
          gallery.invalidateCurrItems();
        }

        if(firstResize) {
          firstResize = false;
        }

        imageSrcWillChange = false;

      });

      gallery.listen('gettingData', function(index, item) {
        item.src = item.o.src;
        item.w = item.o.w;
        item.h = item.o.h;
      });

      gallery.init();
    };

    // select all gallery elements
    var galleryElements = document.querySelectorAll( gallerySelector );
    for(var i = 0, l = galleryElements.length; i < l; i++) {
      galleryElements[i].setAttribute('data-pswp-uid', i+1);
      galleryElements[i].onclick = onThumbnailsClick;
    }

    // Parse URL and open gallery if it contains #&pid=3&gid=1
    var hashData = photoswipeParseHash();
    if(hashData.pid && hashData.gid) {
      openPhotoSwipe( hashData.pid,  galleryElements[ hashData.gid - 1 ], true, true );
    }
  }
}
